<template>
    <tr>
        <td>
            {{ categoryTitle }}
        </td>
        <td class="text-left">
            <div>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-icon small v-on="on" v-text="statusIcon" />
                    </template>
                    <span>{{ statusText }}</span>
                </v-tooltip>
                {{ item.heading }}
            </div>
        </td>
        <td class="text-left">
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <span v-on="on">{{ dates.date }}</span>
                </template>
                <span>
                    Meldung: {{ dates.date }}<br />
                    {{ $t('updated') }}: {{ dates.updatedAt }}<br />
                    {{ $t('created') }}: {{ dates.createdAt }}<br />
                </span>
            </v-tooltip>
        </td>
        <td>
            <v-btn
                fab
                depressed
                small
                color="primary"
                @click="$emit('editItem', { item, index })"
            >
                <v-icon>
                    edit
                </v-icon>
            </v-btn>
            <v-btn
                fab
                depressed
                small
                color="error"
                @click="$emit('removeItemConfirmation', item)"
                :disabled="$wait.is('delete item ' + item.id)"
            >
                <v-icon v-if="$wait.is('delete item ' + item.id)">
                    mdi-loading mdi-spin
                </v-icon>
                <v-icon v-else>
                    clear
                </v-icon>
            </v-btn>
        </td>
    </tr>
</template>

<script>
import { dateTypes, parseISO, formatDate } from '@/utils/dateFns';

export default {
    name: 'AdminCommunityListTableRow',
    props: {
        item: {
            type: Object,
            default: null,
        },
        index: {
            type: Number,
            default: null,
        },
        category: {
            type: Object,
            default: null,
        },
        penaltyFeeCategoryItems: {
            type: Array,
            default: () => [],
        },
        departmentCategoryItems: {
            type: Array,
            default: () => [],
        },
        statusItems: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        penaltyFeeCategory() {
            if (
                this.category.value !== 'penalty_fee' ||
                !this.item.penaltyFeeCategory
            ) {
                return null;
            }
            return this.penaltyFeeCategoryItems.find(
                x => x.value === this.item.penaltyFeeCategory
            );
        },
        departmentCategory() {
            if (
                this.category.value !== 'scenario' ||
                !this.item.departmentCategory
            ) {
                return null;
            }
            return this.departmentCategoryItems.find(
                x => x.id === this.item.departmentCategory
            );
        },
        categoryTitle() {
            if (!this.category || !this.category.text) {
                return null;
            }
            let strAppend = '';
            if (this.departmentCategory && this.departmentCategory.title) {
                strAppend = ` (${this.departmentCategory.title})`;
            } else if (
                this.penaltyFeeCategory &&
                this.penaltyFeeCategory.text
            ) {
                strAppend = ` (${this.penaltyFeeCategory.text})`;
            }
            return this.category.text + strAppend;
        },
        statusIcon() {
            if (this.item.status === 'draft') {
                return 'mdi-pen';
            }
            if (this.item.status === 'preview') {
                return 'mdi-eye-outline';
            }
            if (this.item.status === 'published') {
                return 'mdi-earth';
            }
            return 'mdi-pen';
        },
        statusText() {
            return this.statusItems.find(x => x.value === this.item.status)
                .text;
        },
        dates() {
            return {
                date:
                    this.item &&
                    this.item.date &&
                    this.item.date.substring(0, 1) === '-'
                        ? 'NaN'
                        : formatDate(
                              parseISO(this.item.date),
                              dateTypes.fullDate
                          ),
                createdAt: formatDate(
                    parseISO(this.item.createdAt),
                    dateTypes.fullDate
                ),
                updatedAt: formatDate(
                    parseISO(this.item.updatedAt),
                    dateTypes.fullDate
                ),
            };
        },
    },
};
</script>
